import React, { useEffect, useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { CircularProgress, FormControl, Link } from '@material-ui/core';
import { ErrorBlock, ButtonSubmit, PasslyTextField } from '@app/components';
import { accountService } from '@app/services';
import { SetVerificationCode, SetIsResetToken } from '@app/models';

import { checkIsUserRegisteredPhone } from '../helpers';

interface IProps {
    contextToken: string;
    setIsResetToken: SetIsResetToken;
}

const handleChangeVerificationCode = (setVerificationCode: SetVerificationCode) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setVerificationCode(e.target.value);
};

export const Reset2faToken: React.SFC<IProps> = ({ contextToken, setIsResetToken }) => {
    const { translation } = useTypedTranslation();
    const [isError, setIsError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isEmptyCodeField, setIsEmptyCodeField] = useState<boolean>(false);
    const [isResendingCode, setIsResendingCode] = useState<boolean>(false);
    const [verificationCode, setVerificationCode] = useState<string>('');

    const handleError = (error: any) => {
        setIsError(true);
        if (error.response.data.error === 'ratelimit') {
            setErrorMessage(translation('RATE_LIMIT_ERROR'));
        } else {
            setErrorMessage(translation('GENERIC_SERVER_ERROR'));                    
        }
    };

    const handleSubmit = (e: React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsEmptyCodeField(!verificationCode);

        if (verificationCode) {
            accountService.resetMFAToken(contextToken, verificationCode, setIsResetToken, setIsError);
        }
    };
    const handleResendCode = (e: React.MouseEvent) => {
        e.preventDefault();
        setIsResendingCode(true);
        setIsError(false);

        checkIsUserRegisteredPhone(contextToken, handleError, setIsResendingCode);
    };

    useEffect(() => {
        checkIsUserRegisteredPhone(contextToken, handleError, setIsResendingCode);
    }, []);

    return (
        <>
            <div className='reset-password'>
                <h1>{translation('RESET_2FA_TOKEN')}</h1>
                <ErrorBlock className='reset-password__error' isError={isError} errorMessage={errorMessage ?? translation('RESET_VALIDATION_CODE_ERROR')} />
                <p className='reset-password__form-text'>{translation('RESET_SMS_SENT_MESSAGE')}</p>

                <form onSubmit={handleSubmit}>
                    <FormControl fullWidth>
                        <PasslyTextField
                            value={verificationCode}
                            label={'RESET_CODE_LABEL'}
                            onChange={handleChangeVerificationCode(setVerificationCode)}
                            error={isError || isEmptyCodeField}
                            helperText={isEmptyCodeField && translation('EMPTY_FIELD_ERROR')}
                            required
                            id='code-input'
                            fullWidth
                        />
                    </FormControl>
                    <div className='reset-password__buttons'>
                        <ButtonSubmit
                            className='reset-password__button-next'
                            isLoad={false}
                            buttonText={translation('RESET_2FA_TOKEN')}
                            isDisabled={false}
                            disableRipple={true}
                        />
                    </div>
                    <div className='reset-password__resend'>
                        {translation('PASSWORD_RESEND_CODE')}
                        <Link onClick={handleResendCode}>
                            <span className={isResendingCode ? 'reset-password__resend-invisible' : ''}>{translation('PASSWORD_RESEND')}</span>
                            {isResendingCode && <CircularProgress size={24} className='reset-password__loading__bar' />}
                        </Link>
                    </div>
                </form>
            </div>
        </>
    );
};
